import React from 'react'
import { Redirect } from 'react-router-dom'

class Home extends React.Component {
    render () {
        return (
            <Redirect to='/dashboard' />
        )
    }
}

export default Home



// WEBPACK FOOTER //
// ./resources/js/pages/Home.js